// extracted by mini-css-extract-plugin
module.exports = {"megaMenu":"MegaMenu_megaMenu__rLvD2","content":"MegaMenu_content__vzhKu","active":"MegaMenu_active__mxzUI","wrapper":"MegaMenu_wrapper__gIP9d"};